import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function QueuePage() {
    const { org, queueId, canal } = useParams();

    const showVoice = !canal || canal === "voz";
    const showText = !canal || canal === "texto";

    // 📌 Novos estados SEPARADOS para voz e mensagem
    const [waitingVoice, setWaitingVoice] = useState(0);
    const [interactingVoice, setInteractingVoice] = useState(0);
    const [waitingMsg, setWaitingMsg] = useState(0);
    const [interactingMsg, setInteractingMsg] = useState(0);

    useEffect(() => {
        if (!org || !queueId) return;

        /* ================================
           1) GET INITIAL METRICS
        ================================= */
        fetch(`https://queue.kdash.com.br/current/${org}/${queueId}`)
            .then((res) => res.json())
            .then((data) => {
                const results = Array.isArray(data.results) ? data.results : [];

                // Zera antes
                setWaitingVoice(0);
                setInteractingVoice(0);
                setWaitingMsg(0);
                setInteractingMsg(0);

                results.forEach((block) => {
                    const type = block.group?.mediaType;
                    const metricsArray = block.data ?? [];

                    const w = metricsArray.find((m) => m.metric === "oWaiting")?.stats?.count ?? 0;
                    const i = metricsArray.find((m) => m.metric === "oInteracting")?.stats?.count ?? 0;

                    if (type === "voice") {
                        setWaitingVoice(w);
                        setInteractingVoice(i);
                    }
                    if (type === "message") {
                        setWaitingMsg(w);
                        setInteractingMsg(i);
                    }
                });
            })
            .catch(() => {
                setWaitingVoice(0);
                setInteractingVoice(0);
                setWaitingMsg(0);
                setInteractingMsg(0);
            });

        /* ================================
           2) SSE REAL-TIME
        ================================= */
        const es = new EventSource(
            `https://queue.kdash.com.br/listen/${org}/${queueId}`
        );

        es.onmessage = (event) => {
            let parsed;
            try {
                parsed = JSON.parse(event.data);
            } catch {
                return;
            }

            const body = parsed.eventBody;
            if (!body) return;

            const type = body?.group?.mediaType;
            const dataBuckets = Array.isArray(body.data) ? body.data : [];
            const allMetrics = dataBuckets.flatMap((b) =>
                Array.isArray(b.metrics) ? b.metrics : []
            );

            const w = allMetrics.find((m) => m.metric === "oWaiting")?.stats?.count;
            const i = allMetrics.find((m) => m.metric === "oInteracting")?.stats?.count;

            if (type === "voice") {
                if (w !== undefined) setWaitingVoice(w);
                if (i !== undefined) setInteractingVoice(i);
            }

            if (type === "message") {
                if (w !== undefined) setWaitingMsg(w);
                if (i !== undefined) setInteractingMsg(i);
            }
        };

        es.onerror = (err) => console.error("SSE error:", err);

        return () => es.close();
    }, [org, queueId]);

    return (
        <div
            style={{
                padding: 1,
                margin: 0,
                background: "white",
                borderRadius: 12,
                // boxShadow: "0 3px 10px rgba(0,0,0,0.10)",
                display: "inline-block",
                fontFamily: "Inter, Arial",
            }}
        >
            {/* CONTAINER HORIZONTAL */}
            <div
                style={{
                    display: "flex",
                    gap: 5,
                    justifyContent: "center",
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                }}
            >

                {/* ============================================
                🔊 CARD DE VOZ - EXIBIDO SE showVoice = true
            ============================================ */}
                {showVoice && (
                    <div
                        style={{
                            borderRadius: 10,
                            padding: "5px 6px",
                            background: "linear-gradient(135deg, #e8f3ff, #ffffff)",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.07)",
                            border: "1px solid #d4e7ff",
                            minWidth: 90,
                        }}
                    >
                        {/* Título */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 6,
                                fontWeight: "600",
                                color: "#1a73e8",
                                fontSize: 13,
                            }}
                        >
                            <span style={{ fontSize: 16, marginRight: 6 }}>📞</span>
                            Voz
                        </div>

                        {/* Conteúdo */}
                        <p style={{ margin: "2px 0", color: "#444", fontSize: 12 }}>
                            <strong>Aguardando:</strong>{" "}
                            <span style={{ color: "#e67e22", fontWeight: 700 }}>
                                {waitingVoice}
                            </span>
                        </p>

                        <p style={{ margin: "2px 0", color: "#444", fontSize: 12 }}>
                            <strong>Interagindo:</strong>{" "}
                            <span style={{ color: "#27ae60", fontWeight: 700 }}>
                                {interactingVoice}
                            </span>
                        </p>
                    </div>
                )}

                {/* ============================================
                💬 CARD DE TEXTO - EXIBIDO SE showText = true
            ============================================ */}
                {showText && (
                    <div
                        style={{
                            borderRadius: 10,
                            padding: "5px 6px",
                            background: "linear-gradient(135deg, #fff3e6, #ffffff)",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.07)",
                            border: "1px solid #ffe1c4",
                            minWidth: 90,
                        }}
                    >
                        {/* Título */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 6,
                                fontWeight: "600",
                                color: "#d35400",
                                fontSize: 13,
                            }}
                        >
                            <span style={{ fontSize: 16, marginRight: 6 }}>💬</span>
                            Texto
                        </div>

                        {/* Conteúdo */}
                        <p style={{ margin: "2px 0", color: "#444", fontSize: 12 }}>
                            <strong>Aguardando:</strong>{" "}
                            <span style={{ color: "#e67e22", fontWeight: 700 }}>
                                {waitingMsg}
                            </span>
                        </p>

                        <p style={{ margin: "2px 0", color: "#444", fontSize: 12 }}>
                            <strong>Interagindo:</strong>{" "}
                            <span style={{ color: "#27ae60", fontWeight: 700 }}>
                                {interactingMsg}
                            </span>
                        </p>
                    </div>
                )}

            </div>
        </div>
    );



}

export default QueuePage;
